export default __webpack_public_path__ + "static/media/a011-02.eba48c5d.jpg";